import ApiCaller from 'actions/ApiCaller';
import baseConfig from 'actions/BaseAjaxConfig';
export var catalogActionsEnum;
(function (catalogActionsEnum) {
    catalogActionsEnum["CATALOG_LIST_REQUEST"] = "CATALOG_LIST_REQUEST";
    catalogActionsEnum["CATALOG_LIST_SUCCESS"] = "CATALOG_LIST_SUCCESS";
    catalogActionsEnum["CATALOG_LIST_ERROR"] = "CATALOG_LIST_ERROR";
    catalogActionsEnum["SELECT_CATALOG"] = "SELECT_CATALOG";
    catalogActionsEnum["CATALOG_REQUEST"] = "CATALOG_REQUEST";
    catalogActionsEnum["CATALOG_RESPONSE"] = "CATALOG_RESPONSE";
    catalogActionsEnum["CATALOG_ERROR"] = "CATALOG_ERROR";
    catalogActionsEnum["SUB_CATALOG_REQUEST"] = "SUB_CATALOG_REQUEST";
    catalogActionsEnum["SUB_CATALOG_RESPONSE"] = "SUB_CATALOG_RESPONSE";
    catalogActionsEnum["SUB_CATALOG_ERROR"] = "SUB_CATALOG_ERROR";
    catalogActionsEnum["SELECT_SUB_CATALOG"] = "SELECT_SUB_CATALOG";
    catalogActionsEnum["RESET_SELECTED_CATALOG"] = "RESET_SELECTED_CATALOG";
})(catalogActionsEnum || (catalogActionsEnum = {}));
export function fetchCatalogList() {
    return (dispatch) => {
        dispatch({ type: catalogActionsEnum.CATALOG_LIST_REQUEST });
        const pathname = '/api/1/self-serve/helpcenter/rootCatalog';
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            action: catalogActionsEnum.CATALOG_LIST_REQUEST
        })).then(data => {
            dispatch({
                type: catalogActionsEnum.CATALOG_LIST_SUCCESS,
                data: data.RESPONSE.catalogs
            });
        }, error => {
            dispatch({ type: catalogActionsEnum.CATALOG_LIST_ERROR, error });
        });
    };
}
export function selectCatalog(id) {
    return { type: catalogActionsEnum.SELECT_CATALOG, id };
}
export function selectSubCatalog(id) {
    return { type: catalogActionsEnum.SELECT_SUB_CATALOG, id };
}
export function fetchSelectedCatalog(catalogId, subCatalogId) {
    return (dispatch) => {
        dispatch(selectCatalog(catalogId));
        dispatch({ type: catalogActionsEnum.CATALOG_REQUEST });
        const pathname = '/api/1/self-serve/helpcenter/catalog';
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            query: { catalogId },
            action: catalogActionsEnum.CATALOG_REQUEST
        })).then(data => {
            dispatch({
                type: catalogActionsEnum.CATALOG_RESPONSE,
                data: data.RESPONSE
            });
            dispatch(selectSubCatalog(subCatalogId));
            if (subCatalogId) {
                dispatch(fetchSelectedSubCatalog(subCatalogId));
            }
        }, error => {
            dispatch({ type: catalogActionsEnum.CATALOG_ERROR, error });
        });
    };
}
export function fetchSelectedSubCatalog(id) {
    return (dispatch) => {
        dispatch({ type: catalogActionsEnum.SUB_CATALOG_REQUEST });
        const pathname = '/api/1/self-serve/helpcenter/catalog';
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            query: { catalogId: id },
            action: catalogActionsEnum.SUB_CATALOG_REQUEST
        })).then(data => {
            dispatch({
                type: catalogActionsEnum.SUB_CATALOG_RESPONSE,
                data: data.RESPONSE
            });
        }, error => {
            dispatch({ type: catalogActionsEnum.SUB_CATALOG_ERROR, error });
        });
    };
}
export function resetSubCatalogs() {
    return { type: catalogActionsEnum.RESET_SELECTED_CATALOG };
}
